import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/:id',
  title: 'Editar usuário',
  endpoint: '/app/person',
}
